module.exports = __webpack_public_path__ + "img/book-2.b1bf0873.png";